import { cn } from "@/lib/utils";
import IconWrapper from "./IconWrapper";

export const GeminiIcon = ({ className = "", size = 24, ...props }) => (
  <IconWrapper className={className} size={size} {...props}>
    <svg
      className={cn(className)}
      fill="#1967D2"
      fillRule="evenodd"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Gemini</title>
      <path d="M12 24A14.304 14.304 0 000 12 14.304 14.304 0 0012 0a14.305 14.305 0 0012 12 14.305 14.305 0 00-12 12" />
    </svg>
  </IconWrapper>
);

export default GeminiIcon;
